module.exports = __webpack_public_path__ + "static/fr-logo100-web-white-f6181fd2619fb7b1d82c02aa3722dce0.svg";